module.exports = __webpack_public_path__ + "img/1397527832.2cd3a1c6.jpg";